import React, { useState } from 'react';

export default function RiseUp365() {
  const [billingCycle, setBillingCycle] = useState('monthly');

  return (
    <div className="bg-slate-950 text-slate-100 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto space-y-12">
        <div className="bg-slate-900 rounded-3xl p-8 sm:p-12 border border-slate-800 shadow-2xl grid md:grid-cols-2 gap-8 items-center">
          <div className="space-y-6">
            <div className="w-20 h-20 rounded-2xl bg-slate-950 border border-slate-800 flex items-center justify-center overflow-hidden">
              <img src="/Logo.png" alt="Logo" className="w-12 h-12 object-contain" onError={(e)=>{e.target.style.display='none'}} />
            </div>
            <h1 className="text-3xl sm:text-4xl font-black text-white">RiseUp 365</h1>
            <p className="text-indigo-400 font-bold text-sm">Empowering the Next Generation to Rise in Christ</p>
            <p className="text-slate-400 text-sm leading-relaxed">
              A Christian devotional app for teenagers ages 13–17, offering daily devotionals, Bible studies, prayers, and practical life lessons.
            </p>
          </div>
          <div className="h-64 sm:h-80 rounded-2xl bg-slate-950 border border-slate-800 overflow-hidden relative flex items-center justify-center">
            <img src="/riseup-banner.png" alt="RiseUp Mockup" className="w-full h-full object-cover bg-white" onError={(e)=>{e.target.style.display='none'}} />
            
          </div>
        </div>

        <div className="bg-slate-900 rounded-3xl p-8 sm:p-10 border border-slate-800 text-center">
          <h2 className="text-2xl font-black text-white mb-3">Flexible Pricing Plans</h2>
          <div className="inline-flex bg-slate-950 border border-slate-800 p-1.5 rounded-2xl mb-8">
            <button onClick={() => setBillingCycle('monthly')} className={`py-2 px-6 rounded-xl text-xs font-bold transition ${billingCycle === 'monthly' ? 'bg-blue-600 text-white' : 'text-slate-400'}`}>Monthly</button>
            <button onClick={() => setBillingCycle('annual')} className={`py-2 px-6 rounded-xl text-xs font-bold transition ${billingCycle === 'annual' ? 'bg-blue-600 text-white' : 'text-slate-400'}`}>Annual Plan</button>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto text-left">
            <div className="bg-slate-950 p-8 rounded-2xl border border-slate-800 flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-black text-white">Standard Plan</h3>
                <p className="text-4xl font-black text-blue-400 my-4">$2.99<span className="text-xs font-normal text-slate-500"> /month</span></p>
                <p className="text-xs text-slate-400 mb-6">Includes a 7-Day FREE Trial with daily devotionals, faith affirmations, and guided prayers.</p>
              </div>
            </div>

            <div className="bg-blue-950 p-8 rounded-2xl border border-blue-900/50 flex flex-col justify-between">
              <div>
                <span className="text-[10px] font-black uppercase bg-blue-600 text-white px-3 py-1 rounded-full">Best Value</span>
                <h3 className="text-2xl font-black text-white mt-3">1 Year Plan</h3>
                <p className="text-4xl font-black text-white my-4">$24.99<span className="text-xs font-normal text-blue-300"> /year</span></p>
                <p className="text-xs text-blue-100 mb-6">Save ~30% with a 7-Day FREE Trial, premium faith resources, and exclusive leadership content.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}